import React, { Component } from 'react';
import { Form, Button } from 'semantic-ui-react';
import styles from './navbar_main.scss';
import Signin from '../user/signin';
import UserDropdown from '../user/UserDropdown';
import {Link} from "react-router-dom";

class Navbar_main extends Component {
  constructor() {
    super();
    this.state = {
    };
  }


  render() {
    const IsLogin = localStorage.hasOwnProperty('user');
    return (
      <div className='navbar_main'>
       <Link to={{pathname: `/`,
        }}>
          <div className="main_page">NEXTAPT</div>
        </Link>
        <div className='button-group'>
              {IsLogin?
                  <UserDropdown user={localStorage.getItem('user')} token={localStorage.getItem('token')}/>:
                  <Signin/>
              }
        </div>
      </div>
    );
  }
}


export default Navbar_main;
